__turbopack_context__.v({
  "alignItemsCenter": "DealsListNew-module__7FOJWW__alignItemsCenter",
  "authorName": "DealsListNew-module__7FOJWW__authorName",
  "bookBoxBody": "DealsListNew-module__7FOJWW__bookBoxBody",
  "bookCardBox": "DealsListNew-module__7FOJWW__bookCardBox",
  "bookImage": "DealsListNew-module__7FOJWW__bookImage",
  "category": "DealsListNew-module__7FOJWW__category",
  "container": "DealsListNew-module__7FOJWW__container",
  "dFlex": "DealsListNew-module__7FOJWW__dFlex",
  "dealspage__loader": "DealsListNew-module__7FOJWW__dealspage__loader",
  "descriptionText": "DealsListNew-module__7FOJWW__descriptionText",
  "desktopDescription": "DealsListNew-module__7FOJWW__desktopDescription",
  "imageContainer": "DealsListNew-module__7FOJWW__imageContainer",
  "imgBox": "DealsListNew-module__7FOJWW__imgBox",
  "justifyContentSpaceBetween": "DealsListNew-module__7FOJWW__justifyContentSpaceBetween",
  "loadMoreText": "DealsListNew-module__7FOJWW__loadMoreText",
  "loadingText": "DealsListNew-module__7FOJWW__loadingText",
  "mobielDescription": "DealsListNew-module__7FOJWW__mobielDescription",
  "mobileDescription": "DealsListNew-module__7FOJWW__mobileDescription",
  "mobileReviewSec": "DealsListNew-module__7FOJWW__mobileReviewSec",
  "moreLessButton": "DealsListNew-module__7FOJWW__moreLessButton",
  "moreText": "DealsListNew-module__7FOJWW__moreText",
  "oldPrice": "DealsListNew-module__7FOJWW__oldPrice",
  "previewLink": "DealsListNew-module__7FOJWW__previewLink",
  "pricingBox": "DealsListNew-module__7FOJWW__pricingBox",
  "pricingDetail": "DealsListNew-module__7FOJWW__pricingDetail",
  "promoBanner": "DealsListNew-module__7FOJWW__promoBanner",
  "promoPriceText": "DealsListNew-module__7FOJWW__promoPriceText",
  "readPreview": "DealsListNew-module__7FOJWW__readPreview",
  "reviewCount": "DealsListNew-module__7FOJWW__reviewCount",
  "reviewSec": "DealsListNew-module__7FOJWW__reviewSec",
  "siteBox": "DealsListNew-module__7FOJWW__siteBox",
  "siteListing": "DealsListNew-module__7FOJWW__siteListing",
  "star": "DealsListNew-module__7FOJWW__star",
  "titleText": "DealsListNew-module__7FOJWW__titleText",
});
